// @ts-nocheck
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useAnchor from "@toolkit/Framework/Common/Hooks/useAnchor";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC, useMemo } from "react";

interface OwnProps extends ExpandStyles<AnchorHeadingStyles> {
    anchor: string;
    forwardAs?: TypographyPresentationProps["forwardAs"];
    label?: string;
    title: string;
    variant?: TypographyPresentationProps["variant"];
}

type Props = OwnProps;

export interface AnchorHeadingStyles {
    title?: TypographyPresentationProps;
}

export const AnchorHeadingStyles: AnchorHeadingStyles = {
    title: {
        variant: "h2",
    },
};

const AnchorHeading: FC<Props> = ({ anchor, extendedStyles, forwardAs, label, overridedStyles, title, variant }) => {
    const styles = useExpandProps(AnchorHeadingStyles, extendedStyles, overridedStyles);
    const anchorId = useAnchor(anchor ?? title, label || title);

    const titleStyle: TypographyPresentationProps = useMemo(
        () => ({
            ...styles.title,
            forwardAs: forwardAs || styles.title?.forwardAs,
            variant: variant || styles.title?.variant,
        }),
        [forwardAs, variant, extendedStyles, overridedStyles],
    );

    return (
        <Typography id={anchorId} {...titleStyle}>
            {title}
        </Typography>
    );
};

export default AnchorHeading;
